import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Expander from 'components/expander';

const HousingProjectInformationList = ({ items, baseTheme, visibleCount }) => {
  const hasExpander =
    items &&
    typeof visibleCount === 'number' &&
    visibleCount > 0 &&
    items.length > visibleCount;

  const visibleItems = hasExpander ? items.slice(0, visibleCount) : items;
  const hiddenItems = hasExpander ? items.slice(visibleCount) : [];

  const itemsRenderer = arr =>
    arr.map(item => (
      <React.Fragment key={item.label}>
        <dt className="housing-project-information-list__label">
          {item.label}
        </dt>
        <dd className="housing-project-information-list__text">{item.text}</dd>
      </React.Fragment>
    ));
  return (
    <div
      className={cn('housing-project-information-list', {
        [`housing-project-information-list--${baseTheme}`]: baseTheme
      })}
    >
      {items && (
        <dl className="housing-project-information-list__items">
          {itemsRenderer(visibleItems)}
        </dl>
      )}
      {hasExpander && (
        <Expander
          showText="Vis mer"
          hideText="Vis mindre"
          theme="information"
          color={baseTheme}
        >
          <dl className="housing-project-information-list__items">
            {itemsRenderer(hiddenItems)}
          </dl>
        </Expander>
      )}
    </div>
  );
};

HousingProjectInformationList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, text: PropTypes.string })
  ),
  baseTheme: PropTypes.string,
  visibleCount: PropTypes.number
};

HousingProjectInformationList.propTypesMeta = {
  baseTheme: 'exclude'
};

export default HousingProjectInformationList;
